// i18n/I18nContext.tsx - Error-free version
import { createContext, useContext } from 'react'
import type { LanguageCode } from '../types'

export interface I18nContextType {
    language: LanguageCode
    setLanguage: (lang: LanguageCode) => void
    t: (key: string) => string
}

export const I18nContext = createContext<I18nContextType | undefined>(undefined)

// i18n/I18nContext.tsx - Updated t function
export const useI18n = () => {
    const context = useContext(I18nContext)
    if (!context) throw new Error('useI18n must be used within an I18nProvider')

    const enhancedT = (key: string, options?: { returnObjects?: boolean }) => {
        const result = context.t(key)
        if (options?.returnObjects) {
            try {
                return JSON.parse(result)
            } catch {
                return result
            }
        }
        return result
    }

    return { ...context, t: enhancedT }
}
